import RecapPage from 'pages/RecapPage/RecapPage'

export default RecapPage
